import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { FaChevronUp } from 'react-icons/fa';

const ScrollButton = styled.button`
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  background-color: #cc0000;
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
  transition: opacity 0.3s, transform 0.3s;
  opacity: ${(props) => (props.visible ? 1 : 0)};
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};

  &:hover {
    background-color: #a00000;
    transform: scale(1.1);
  }

  @media (max-width: 768px) {
    right: 10px;
    width: 40px;
    height: 40px;
  }
`;

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        const container = document.getElementById('main-content') || window;
        const scrollPosition = container === window ? window.scrollY : container.scrollTop;

        console.log("Scroll Position:", scrollPosition);
        if (scrollPosition > 200) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        const container = document.getElementById('main-content') || window;

        console.log("Adding scroll listener to:", container === window ? 'window' : '#main-content');
        container.addEventListener('scroll', toggleVisibility);

        return () => {
            console.log("Removing scroll listener from:", container === window ? 'window' : '#main-content');
            container.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    return (
        <ScrollButton onClick={scrollToTop} visible={isVisible}>
            <FaChevronUp style={{ width: '20px', height: '20px' }} />
        </ScrollButton>
    );
};

export default ScrollToTopButton;
